import { Modal } from "antd"
import { error_manager } from "helper/error_manager"
import { post } from "helper/request"
import { Component } from "react"


class PatientFolderDeleteModal extends Component {
    constructor(props) {
        super(props)
    }

    handleDelete = () => {
        const requests = []

        for (const { id } of this.props.folders) {
            const url = "/api/delete_patient_folder/"
            const data = { id }

            const request = post(url, data)
            requests.push(request)
        }

        Promise.allSettled(requests)
            .then(() => window.location.reload())
            .catch(err => error_manager("unable to delete folder", err))
            .finally(this.props.closeModal)
    }

    render() {
        return (
            <Modal
                visible={true}
                onCancel={this.props.closeModal}
                onOk={this.handleDelete}
            >
                <h3>Are you sure, you want to delete following folder?</h3>
                <h4>This will not delete any folder contents i.e. cases and slides</h4>
                <ul>
                    {this.props.folders.map(({ folder_name }) => (
                        <li>{folder_name}</li>
                    ))}
                </ul>
            </Modal>
        )
    }
}

export default PatientFolderDeleteModal